import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	descriptionPlaceholder: {
		id: 'software-releases-version-summary-description.editable-version-summary-description.description-placeholder',
		defaultMessage: 'No description added yet.',
		description: 'Placeholder text when description field is empty',
	},
	errorFlagTitle: {
		id: 'software-releases-version-summary-description.editable-version-summary-description.error-flag-title',
		defaultMessage: "We couldn't update the description",
		description: 'Flag title for failure to update version description',
	},
	errorFlagDescription: {
		id: 'software-releases-version-summary-description.editable-version-summary-description.error-flag-description',
		defaultMessage:
			'Something went wrong. Please try again or contact your administrator if the problem persists.',
		description: 'Flag description for failure to update version description',
	},
	maxDescriptionSizeExceededErrorMessage: {
		id: 'software-releases-version-summary-description.editable-version-summary-description.max-description-size-exceeded-error-message',
		defaultMessage: 'Maximum description size exceeded',
		description: 'Error message when the version description size exceeds the maximum size limit',
	},
});
